import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 px-6 bg-secondary text-secondary-foreground" role="contentinfo">
      <div className="max-w-6xl mx-auto">
        {/* Footer Navigation */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Company */}
          <nav aria-label="Company links">
            <h3 className="font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-sm text-secondary-foreground/80">
              <li><Link to="/about" className="hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/careers" className="hover:text-primary transition-colors">Careers</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
              <li><Link to="/blog" className="hover:text-primary transition-colors">Blog</Link></li>
            </ul>
          </nav>

          {/* Product */}
          <nav aria-label="Product links">
            <h3 className="font-semibold mb-4">Product</h3>
            <ul className="space-y-2 text-sm text-secondary-foreground/80">
              <li><Link to="/dashboard" className="hover:text-primary transition-colors">Resume Builder</Link></li>
              <li><Link to="/templates" className="hover:text-primary transition-colors">Templates</Link></li>
              <li><Link to="/features/ai-writer" className="hover:text-primary transition-colors">AI Resume Writer</Link></li>
              <li><Link to="/features/ats-optimizer" className="hover:text-primary transition-colors">ATS Optimizer</Link></li>
            </ul>
          </nav>

          {/* Resources */}
          <nav aria-label="Resources links">
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm text-secondary-foreground/80">
              <li><Link to="/blog/resume-examples" className="hover:text-primary transition-colors">Resume Examples</Link></li>
              <li><Link to="/blog/cover-letter-guide" className="hover:text-primary transition-colors">Cover Letter Guide</Link></li>
              <li><Link to="/blog/ats-tips" className="hover:text-primary transition-colors">ATS Tips</Link></li>
              <li><Link to="/help" className="hover:text-primary transition-colors">Help Center</Link></li>
            </ul>
          </nav>

          {/* Legal */}
          <nav aria-label="Legal links">
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm text-secondary-foreground/80">
              <li><Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-primary transition-colors">Terms of Service</Link></li>
              <li><Link to="/cookies" className="hover:text-primary transition-colors">Cookie Policy</Link></li>
            </ul>
          </nav>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-secondary-foreground/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className="bg-white rounded-lg p-2">
                <img src={logo} alt="AI CV WALA" className="h-10 w-auto" width="45" height="40" loading="lazy" />
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-lg">AI CV WALA</span>
                <span className="text-xs text-secondary-foreground/70">Professional Resume Builder</span>
              </div>
            </div>
            
            <p className="text-secondary-foreground/80 text-sm">
              Where human expertise meets your career dreams.
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-between gap-4 mt-6">
            <div className="flex items-center gap-1 text-sm text-secondary-foreground/70">
              Made with <Heart className="w-4 h-4 text-primary fill-primary" aria-hidden="true" /> by humans, for humans
            </div>
            <p className="text-xs text-secondary-foreground/70">
              © {currentYear} AI CV WALA. All rights reserved.
            </p>
          </div>
        </div>

        {/* SEO-friendly text block */}
        <div className="mt-8 pt-8 border-t border-secondary-foreground/10">
          <p className="text-xs text-secondary-foreground/70 max-w-4xl mx-auto text-center">
            AI CV WALA is a free AI-powered resume builder that helps job seekers create professional, ATS-optimized resumes. 
            Our platform offers 50+ templates, real ATS score testing, job description matching, and intelligent content suggestions. 
            Build your resume online for free and get more interview callbacks.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
